import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import Tooltip from '../Tooltip';
import styles from './index.module.scss';

const CopyToClipboardField = ({ id, copyText, label }) => (
  <div className={styles.row}>
    <div className={styles.fieldContainer}>
      <label htmlFor={id}>
        <p>{label}</p>
      </label>
      <input
        disabled
        className={styles.textCopyField}
        id={id}
        type="text"
        value={copyText}
      />
    </div>

    <Tooltip
      interactive
      content={I18n.t('copied_to_clipboard')}
      placement="bottom"
      trigger="click"
    >
      <button
        className={`btn btn--outline-purple js-clipboard-trigger ${styles.copyButton}`}
        data-clipboard-text={copyText}
        type="button"
      >
        {I18n.t('copy')}
      </button>
    </Tooltip>
  </div>
);

CopyToClipboardField.propTypes = {
  copyText: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default CopyToClipboardField;
